@if (!iEmpty) {
  <nav aria-label="Pagination" id="nav-pagination" class="app-pagination">
    @if (iPageSize != null) {
      <div class="app-pagination-summary">
        {{ pageSizeLabel }}
      </div>
    }
    <div class="app-pagination-controls">
      <button type="button" class="app-pagination-btn" (click)="changePage('previous')" [disabled]="iFirst" aria-label="Page précédente">
        <span aria-hidden="true">&lsaquo;</span>
      </button>
      <span class="app-pagination-current">
        {{ currentPageDisplay }}
        <span class="visually-hidden">(page courante)</span>
      </span>
      <button type="button" class="app-pagination-btn" (click)="changePage('next')" [disabled]="iLast" aria-label="Page suivante">
        <span aria-hidden="true">&rsaquo;</span>
      </button>
    </div>
  </nav>
}
